import { FormattedMessage } from "react-intl";

export const GeneratingDOI = () => (
  <div className="w-full font-medium text-center">
    <span className="font-medium text-transparent bg-clip-text bg-linear-to-r from-[#667085] to-[#E2E6ED] animate-pulse">
      <FormattedMessage defaultMessage="Generating DOI..." />
    </span>
  </div>
);
